import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_front-desk/sarah/agent")({
  beforeLoad: ({ context }) => guardRoute(context.me, "sarah-agent"),
  component: Outlet,
});
